import React from 'react';
import ProjectInfoWrapper from '../ProjectInfoWrapper';
import SNavigation from '../SNavigation';

const GenericRoute = ({ projectID, transcriptID, page, codeID, rightSideBar = false }) => (
  <ProjectInfoWrapper
    projectID={projectID}
  >
    <SNavigation
      transcriptID={transcriptID}
      page={page}
      rightSideBar={rightSideBar}
      codeID={codeID}
    />
  </ProjectInfoWrapper>
);

export default GenericRoute;
